import {
  COLUMN_TYPE_SETTING,
  DATE_TIME_FORMAT,
  SERVICES,
} from "@lhd/constants";
import {
  APP_PART_TYPES,
  DEFAULT_WIDTH_COL,
} from "@lhd/features/Apps/AppForm/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import {
  EMPLOYEE_INFO_CHILD_APP_PART_TYPES,
  getPrimaryCompanyNameDisplayText,
} from "@lhd/features/Apps/utils";
import { getCompanyId, isJSON } from "@lhd/utility";
import { Column, OptionType } from "@silevis/reactgrid";
import axios from "@lhd/libs/axios";
import moment from "moment";
import { RecordType } from "../../types";
import { cloneDeep, isEmpty, toNumber } from "lodash";
import { AppRecord } from "types/app.type";
import { useMemo } from "react";
import axiosV2 from "@lhd/libs/axiosV2";
import { HIDDENS_COLUMNS_SHEET } from "@lhd/features/Apps/constants";
import {
  MARGIN,
  POPUP_HEIGHT,
  POPUP_WIDTH,
} from "./AppSheetComponents/ColorPicker/const";
import dayjs from "dayjs";

export const useColumns = (
  appPartList?: AppPartType[],
  isOnlyViewAppPermission = false,
  config?: { [key: string]: any },
) => {
  return useMemo(() => {
    if (!appPartList?.length) return [];
    return (
      appPartList
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((ap) => {
          const width = ap.width || DEFAULT_WIDTH_COL;
          const isModal = listAppPartTypeOpenModal.includes(
            ap.app_part_type as any,
          );
          const fieldCommons = {
            columnId: ap.id?.toString() || "",
            copy_from_app_part_id: ap?.copy_from_app_part_id,
            label: ap.is_hide_name
              ? ""
              : (ap.label_text || ap.name)?.replace(/<[^>]*>?/gm, "") || "",
            app_part_type: ap.app_part_type,
            width,
            type: "text",
            resizable: true,
            reorderable: true,
            appPart: ap,
          };
          // if (isModal) {
          //   return {
          //     ...fieldCommons,
          //     type: "modalTemplate",
          //   };
          // }

          switch (ap.app_part_type) {
            case APP_PART_TYPES.NUMBER:
              return {
                ...fieldCommons,
                type: "numberCellCustom",
              };
            case APP_PART_TYPES.DATE:
            case APP_PART_TYPES.TIME:
            case APP_PART_TYPES.DATE_AND_TIME:
            case APP_PART_TYPES.SIGNED_DATE:
              return {
                ...fieldCommons,
                type: "dateTimeCustom",
              };
            case APP_PART_TYPES.RADIO_BUTTON:
              return {
                ...fieldCommons,
                type: "text",
              };
            case APP_PART_TYPES.PRIMARY_COMPANY_NAME:
              return {
                ...fieldCommons,
                type: "primaryCompanyNameCellCustom",
              };

            default:
              return {
                ...fieldCommons,
                type: "textCellCustom",
              };
          }
        }) || []
    );
  }, [isOnlyViewAppPermission, appPartList]);
};

export type ReceivedProps = {
  workersOptions?: OptionType[];
  isTable?: boolean;
  appParts?: AppPartType[];
};

export interface ColumnProps extends Column {
  type?: string;
  label?: string;
}
export const SETTING_ROW_HEIGHT = 42;
export const NUM_OF_SETTING_ROW = 8;
export const APP_PART_ROW = "appPartRow";
export const listAppPartTypeOpenModal = [
  APP_PART_TYPES.RICH_TEXT,
  APP_PART_TYPES.ORGANIZATION_SELECTION,
  APP_PART_TYPES.WORKER_SELECTION,
  APP_PART_TYPES.EMPLOYEE_INFO_SELECTION,
  APP_PART_TYPES.DIVISION_SELECTION,
  APP_PART_TYPES.BRANCH_SELECTION,
  APP_PART_TYPES.DEPARTMENT_SELECTION,
  APP_PART_TYPES.COMPANY_LOCATION_SELECTION,
  APP_PART_TYPES.REPRESENTATIVE_SELECTION,
  APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION,
  APP_PART_TYPES.POSITION_SELECTION,
  APP_PART_TYPES.CUSTOMER_SELECTION,
  APP_PART_TYPES.CHECK_BOX,
  APP_PART_TYPES.MULTI_CHOICE,
  APP_PART_TYPES.DROPDOWN,
  APP_PART_TYPES.RADIO_BUTTON,
  APP_PART_TYPES.ATTACHMENT,
  APP_PART_TYPES.RELATED_RECORDS,
  ...EMPLOYEE_INFO_CHILD_APP_PART_TYPES,
];
export const reorderArray = (arr: any[], idxs: number[], to: number) => {
  const movedElements = arr.filter((_, idx) => idxs.includes(idx));
  const targetIdx =
    Math.min(...idxs) < to
      ? (to += 1)
      : (to -= idxs.filter((idx) => idx < to).length);
  const leftSide = arr.filter(
    (_, idx) => idx < targetIdx && !idxs.includes(idx),
  );
  const rightSide = arr.filter(
    (_, idx) => idx >= targetIdx && !idxs.includes(idx),
  );
  return [...leftSide, ...movedElements, ...rightSide];
};

export const columnTypeValueMap = Object.fromEntries(
  COLUMN_TYPE_SETTING.map((item) => [item.type, item.value]),
);

export const getOrgsData = async (id: string) => {
  const rs = await axiosV2({
    method: "get",
    url: SERVICES.ORG_NODES,
    params: {
      page: 1,
      per_page: 9999,
      offset: 0,
      "q[org_id_eq]": id,
      "q[company_id_eq]": getCompanyId(),
    },
  });
  return rs.data;
};
export const getWorkers = async () => {
  const rs = await axiosV2({
    method: "get",
    url: SERVICES.WORKERS + "/list_less_fields",
    params: {
      page: 1,
      per_page: 10000,
      "q[company_id_eq]": getCompanyId(),
      company_id: getCompanyId(),
    },
  });
  return rs.data;
};

export const isSelectionType = (type: string) => {
  return (
    type === APP_PART_TYPES.DIVISION_SELECTION ||
    type === APP_PART_TYPES.BRANCH_SELECTION ||
    type === APP_PART_TYPES.ORGANIZATION_SELECTION ||
    type === APP_PART_TYPES.DEPARTMENT_SELECTION ||
    type === APP_PART_TYPES.WORKER_SELECTION ||
    type === APP_PART_TYPES.EMPLOYEE_INFO_SELECTION ||
    type === APP_PART_TYPES.COMPANY_LOCATION_SELECTION ||
    type === APP_PART_TYPES.REPRESENTATIVE_SELECTION ||
    type === APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION ||
    type === APP_PART_TYPES.POSITION_SELECTION ||
    type === APP_PART_TYPES.CUSTOMER_SELECTION
  );
};
export const sortArrayByUpdatedAt = (a: RecordType, b: RecordType) => {
  const dateA = moment(a.updated_at);
  const dateB = moment(b.updated_at);
  return dateA.isSameOrBefore(dateB) ? 1 : -1;
};
export const sortArrayByCreatedAt = (a: RecordType, b: RecordType) => {
  const dateA = moment(a.created_at);
  const dateB = moment(b.created_at);
  return dateA.isSameOrBefore(dateB) ? 1 : -1;
};
export const getFormat = (type: string) => {
  switch (type) {
    case APP_PART_TYPES.DATE:
      return {
        format: Intl.DateTimeFormat("ja-JP", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
      };
    case APP_PART_TYPES.SIGNED_DATE:
      return {
        format: Intl.DateTimeFormat("ja-JP", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
      };
    case APP_PART_TYPES.TIME:
      return {
        format: Intl.DateTimeFormat("ja-JP", {
          hour: "numeric",
          minute: "numeric",
        }),
      };
    case APP_PART_TYPES.DATE_AND_TIME:
      return {
        format: Intl.DateTimeFormat("ja-JP", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
      };
    default:
      return {};
  }
};
export const settingFieldId = [
  "fieldCode",
  "appPartType",
  "hideTitle",
  "isRequired",
  "isShowColumn",
  "defaultValue",
  "isProhibitDuplicateValues",
];

export const getRowSetting = (
  appPart: AppPartType[],
  setEditingAppPart: (ap: AppPartType) => void,
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "settings",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header",
        nonEditable: true,
        text: "詳細列設定",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows ${lastItemClass}`,
            text: a.field_code || "",
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: "headerSettings",
            onClick: () => {
              setEditingAppPart(a);
            },
          };
        }) || []),
    ],
  };
};
export const getRowAction = (
  appPart: AppPartType[],
  editable?: boolean,
  actions?: {
    addToLeft: () => void;
    addToRight: () => void;
    duplicate: () => void;
    delete: () => void;
  },
  isOnlyViewAppPermission = false,
) => {
  const actionColumns =
    appPart
      ?.filter((appPartItem) => {
        if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
          return false;
        return isOnlyViewAppPermission
          ? appPartItem?.current_detail_permissions?.specified_app_part_read ||
              appPartItem?.current_detail_permissions?.specified_app_part_edit
          : true;
      })
      ?.map((a, i) => {
        const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
        return {
          className: `settings-rows  ignore-tooltip ${lastItemClass}`,
          text: a.field_code || "",
          nonEditable:
            !editable ||
            !a?.current_detail_permissions?.specified_app_part_edit,
          type: "headerActions",
          actions: {
            ...actions,
            delete: actions?.delete,
          },
          appPart: a,
        };
      }) || [];

  return {
    rowId: "actions",
    height: SETTING_ROW_HEIGHT,
    className: "ignore-tooltip",
    cells: [
      {
        ...(actionColumns[0] || {}),
        className: "settings-rows-header ignore-tooltip",
        nonEditable: true,
        text: "操作",
        type: "headerActions",
        isIndexCol: true,
      },
      ...(actionColumns || []),
    ],
  };
};
export const getRowFieldCode = (
  appPart: AppPartType[],
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "fieldCode",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header",
        nonEditable: true,
        text: "列コード",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows ${lastItemClass}`,
            text: a.field_code || "",
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: isHideSetting("fieldCode", a.app_part_type)
              ? "empty"
              : "text",
          };
        }) || []),
    ],
  };
};
export const getRowIsProhibitDuplicateValues = (
  appPart: AppPartType[],
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "isProhibitDuplicateValues",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header",
        nonEditable: true,
        text: "複製値を禁止",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows ${lastItemClass}`,
            checked: a.is_prohibit_duplicate_values,
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: isHideSetting("isProhibitDuplicateValues", a.app_part_type)
              ? "empty"
              : "checkbox",
          };
        }) || []),
    ],
  };
};
export const getRowHideTitle = (
  appPart: AppPartType[],
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "hideTitle",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header",
        nonEditable: true,
        text: "列名を表示しない",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows ${lastItemClass}`,
            checked: a.is_hide_name,
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: isHideSetting("hideTitle", a.app_part_type)
              ? "empty"
              : "checkbox",
          };
        }) || []),
    ],
  };
};
export const getRowRequired = (
  appPart: AppPartType[],
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "isRequired",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header",
        nonEditable: true,
        text: "必須項目にする",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows ${lastItemClass}`,
            checked: a.is_required_field,
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: isHideSetting("isRequired", a.app_part_type)
              ? "empty"
              : "checkbox",
          };
        }) || []),
    ],
  };
};
export const getRowIsShowColumn = (
  appPart: AppPartType[],
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "isShowColumn",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header",
        nonEditable: true,
        text: "列を表示",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows ${lastItemClass}`,
            checked: a.is_show_column,
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: isHideSetting("isShowColumn", a.app_part_type)
              ? "empty"
              : "checkbox",
          };
        }) || []),
    ],
  };
};
export const getRowDefaultValue = (
  appPart: AppPartType[],
  editable?: boolean,
  isOnlyViewAppPermission = false,
) => {
  return {
    rowId: "defaultValue",
    height: SETTING_ROW_HEIGHT,
    cells: [
      {
        className: "settings-rows-header default-row",
        nonEditable: true,
        text: "初期値",
        type: "text",
      },
      ...(appPart
        ?.filter((appPartItem) => {
          if (HIDDENS_COLUMNS_SHEET.includes(appPartItem.app_part_type))
            return false;
          return isOnlyViewAppPermission
            ? appPartItem?.current_detail_permissions
                ?.specified_app_part_read ||
                appPartItem?.current_detail_permissions?.specified_app_part_edit
            : true;
        })
        ?.map((a, i) => {
          const lastItemClass = i === appPart.length - 1 ? "last-item" : "";
          return {
            className: `settings-rows default-row ${lastItemClass}`,
            text: a.default_value || "",
            nonEditable:
              !editable ||
              !a?.current_detail_permissions?.specified_app_part_edit,
            type: isHideSetting("defaultValue", a.app_part_type)
              ? "empty"
              : "text",
          };
        }) || []),
    ],
  };
};
export const handleChangeSetting = (
  appItem: AppPartType,
  rowId: string,
  newValue: any,
) => {
  switch (rowId) {
    case "hideTitle":
      appItem.is_hide_name = newValue;
      break;
    case "isRequired":
      appItem.is_required_field = newValue;
      break;
    case "isShowColumn":
      appItem.is_show_column = newValue;
      break;
    case "fieldCode":
      appItem.field_code = newValue;
      break;
    case "appPartType":
      appItem.app_part_type = newValue;
      break;
    case "isProhibitDuplicateValues":
      appItem.is_prohibit_duplicate_values = newValue;
      break;
    default:
      break;
  }
  return appItem;
};

export const getSelectionDefaultValue = (ap: AppPartType) => {
  if (!isSelectionType(ap.app_part_type)) return;
  const config = ap.item_config_data;
  switch (ap.app_part_type) {
    case APP_PART_TYPES.ORGANIZATION_SELECTION:
      if (config?.default_organizations) {
        return JSON.stringify(
          config?.default_organizations?.map((v) => v.id.toString()),
        );
      }
      return JSON.stringify([]);
    case APP_PART_TYPES.DIVISION_SELECTION:
      if (config?.default_divisions) {
        return JSON.stringify(
          config?.default_divisions?.map((v) => v.id.toString()),
        );
      }
      return JSON.stringify([]);
    case APP_PART_TYPES.DEPARTMENT_SELECTION:
      if (config?.default_departments) {
        return JSON.stringify(
          config?.default_departments?.map((v) => v.id.toString()),
        );
      }
      return JSON.stringify([]);
    case APP_PART_TYPES.BRANCH_SELECTION:
      if (config?.default_branchs) {
        return JSON.stringify(
          config?.default_branchs?.map((v) => v.id.toString()),
        );
      }
      return JSON.stringify([]);
    case APP_PART_TYPES.WORKER_SELECTION:
      if (config?.default_workers) {
        return JSON.stringify(
          config?.default_workers?.map((v) => v.id.toString()),
        );
      }
      return JSON.stringify([]);
    case APP_PART_TYPES.COMPANY_LOCATION_SELECTION:
      return undefined;
    default:
      return JSON.stringify([]);
  }
};
export const getSelectDefaultValue = (ap: AppPartType) => {
  switch (ap.app_part_type) {
    case APP_PART_TYPES.DROPDOWN:
    case APP_PART_TYPES.RADIO_BUTTON:
      return ap.default_value;
    case APP_PART_TYPES.CHECK_BOX:
    case APP_PART_TYPES.MULTI_CHOICE: {
      const options = ap.item_config_data.options
        ?.filter((o) => o.default_checked)
        .map((o) => o.text);
      if (isEmpty(options)) return undefined;
      return JSON.stringify(options);
    }

    default:
      return null;
  }
};
// eslint-disable-next-line prettier/prettier
export const sortAppPartByMetaData = (appParts: AppPartType[]) => {
  if (!appParts) return [];
  const sorted = cloneDeep(appParts).sort(
    (a, b) => Number(a?.sort_index || 0) - Number(b?.sort_index || 0),
  );
  return sorted;
};
// eslint-disable-next-line prettier/prettier
export const sortColumnByMetaData = (
  columns: ColumnProps[],
  metaData: string[],
) => {
  if (!columns) return [];
  if (!metaData) return columns;
  const isAllAppartExistInMetaData = columns.every((ap) =>
    metaData.includes(ap?.columnId?.toString() || ""),
  );
  if (!isAllAppartExistInMetaData) return columns;
  const sortedList = cloneDeep(columns).sort((col1, col2) => {
    if (col1.columnId === "index") {
      return 1;
    }
    if (col2.columnId === "index") {
      return -1;
    }
    const index1 = metaData.findIndex(
      (data) => data.toString() === col1.columnId?.toString(),
    );
    const index2 = metaData.findIndex(
      (data) => data.toString() === col2.columnId?.toString(),
    );
    return index1 > index2 ? 1 : -1;
  });
  return sortedList;
};
export const insertToArray = (arr: any[], index: number, newItem: any[]) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  ...newItem,
  // part of the array after the specified index
  ...arr.slice(index),
];
export const sortRecordDataByCreatedDate = (recordData: AppRecord[]) => {
  const sorted = cloneDeep(recordData)?.sort((data1, data2) => {
    if (!data1.created_at || !data2.created_at) return 0;
    const date1 = new Date(data1.created_at)?.getTime();
    const date2 = new Date(data2.created_at)?.getTime();
    if (date1 > date2) return 1;
    return -1;
  });
  return sorted;
};
export const generateNewId = (appParts: AppPartType[]) => {
  const ids = appParts.map((l) => {
    const itemConfigDataAsJSON = l.item_config_data as unknown as string;
    const itemConfigData = isJSON(l.item_config_data)
      ? JSON.parse(itemConfigDataAsJSON)
      : l.item_config_data;
    return Number(itemConfigData.i);
  });
  const id = String((ids.length > 0 ? Math.max(...ids) : 0) + 1);
  return id;
};

export const isHideSetting = (field: string, appPart: any) => {
  switch (field) {
    case "fieldCode":
    case "hideTitle":
      return [APP_PART_TYPES.LABEL].includes(appPart);
    case "isRequired":
      return [
        APP_PART_TYPES.LABEL,
        APP_PART_TYPES.RADIO_BUTTON,
        APP_PART_TYPES.TABLE,
        APP_PART_TYPES.FIELD_GROUP,
        APP_PART_TYPES.CREATED_BY,
        APP_PART_TYPES.UPDATED_BY,
        APP_PART_TYPES.CREATED_DATETIME,
        APP_PART_TYPES.UPDATED_DATETIME,
        APP_PART_TYPES.RECORD_NUMBER,
        APP_PART_TYPES.EMPLOYEE_SIGNATURE,
      ].includes(appPart);
    case "isProhibitDuplicateValues":
      return ![
        APP_PART_TYPES.DATE_AND_TIME,
        APP_PART_TYPES.DATE,
        APP_PART_TYPES.LINK,
        APP_PART_TYPES.NUMBER,
        APP_PART_TYPES.TEXT,
      ].includes(appPart);
    case "isShowColumn":
      return [
        APP_PART_TYPES.TABLE,
        APP_PART_TYPES.FIELD_GROUP,
        APP_PART_TYPES.CREATED_BY,
        APP_PART_TYPES.UPDATED_BY,
        APP_PART_TYPES.CREATED_DATETIME,
        APP_PART_TYPES.UPDATED_DATETIME,
        APP_PART_TYPES.RECORD_NUMBER,
      ].includes(appPart);
    case "defaultValue":
      return [
        APP_PART_TYPES.LABEL,
        APP_PART_TYPES.TABLE,
        APP_PART_TYPES.FIELD_GROUP,
        APP_PART_TYPES.CREATED_BY,
        APP_PART_TYPES.UPDATED_BY,
        APP_PART_TYPES.CREATED_DATETIME,
        APP_PART_TYPES.UPDATED_DATETIME,
        APP_PART_TYPES.RECORD_NUMBER,
        APP_PART_TYPES.EMPLOYEE_SIGNATURE,
      ].includes(appPart);
    default:
      return true;
  }
};
export const getAttachmentValue = (
  recordValue: { value: string }[] | { value: string },
) => {
  return Array.isArray(recordValue)
    ? recordValue
        .map((recordItem) =>
          decodeURIComponent(recordItem?.value?.split("/")?.pop() || ""),
        )
        .toString()
    : decodeURIComponent(recordValue?.value?.split("/")?.pop() || "");
};

export const calculatePosition = (position: any) => {
  if (!position?.x || !position?.y) {
    return {
      x: Math.max(0, (window.innerWidth - POPUP_WIDTH) / 2),
      y: Math.max(0, (window.innerHeight - POPUP_HEIGHT) / 2),
    };
  }

  const aspectRatio = window.innerWidth / window.innerHeight;

  let posX = position.x;

  if (position.x + POPUP_WIDTH + MARGIN > window.innerWidth) {
    posX = position.x - POPUP_WIDTH - MARGIN;

    if (posX < MARGIN) {
      if (aspectRatio > 1.2 && window.innerWidth > POPUP_WIDTH + 2 * MARGIN) {
        posX = Math.min(
          position.x + MARGIN,
          window.innerWidth - POPUP_WIDTH - MARGIN,
        );
      } else {
        posX = MARGIN;
      }
    }
  } else {
    posX = position.x + MARGIN;
  }

  posX = Math.max(MARGIN, posX);
  posX = Math.min(posX, window.innerWidth - POPUP_WIDTH - MARGIN);

  let posY = position.y;

  if (position.y + POPUP_HEIGHT + MARGIN > window.innerHeight) {
    posY = position.y - POPUP_HEIGHT - MARGIN;

    if (posY < MARGIN) {
      if (aspectRatio < 0.8 && window.innerHeight > POPUP_HEIGHT + 2 * MARGIN) {
        posY = Math.min(
          position.y + MARGIN,
          window.innerHeight - POPUP_HEIGHT - MARGIN,
        );
      } else {
        posY = MARGIN;
      }
    }
  } else {
    posY = position.y + MARGIN;
  }

  posY = Math.max(MARGIN, posY);
  posY = Math.min(posY, window.innerHeight - POPUP_HEIGHT - MARGIN);

  return { x: posX, y: posY };
};

export const getTextTimeCell = (app_part_type: string, text: string) => {
  if (!text) return "";
  if (app_part_type === APP_PART_TYPES.TIME) {
    try {
      const timeValue = dayjs(text);
      if (!timeValue.isValid()) {
        return "";
      }
      return timeValue.format(DATE_TIME_FORMAT.TIME);
    } catch (error) {
      return dayjs("1970-01-01T00:00:00.000Z").format(DATE_TIME_FORMAT.TIME);
    }
  } else if (app_part_type === APP_PART_TYPES.DATE) {
    const date = dayjs(
      text
        ?.replace("年", "-")
        .replace("月", "-")
        .replace("日", "")
        .replaceAll("/", "-"),
    ).format(DATE_TIME_FORMAT.DATE_JP);
    return date === "Invalid Date" ? "1970年01月01日" : date;
  } else if (app_part_type === APP_PART_TYPES.DATE_AND_TIME) {
    const dateTime = dayjs(
      text
        .replace("年", "-")
        .replace("月", "-")
        .replace("日", "")
        .replace("T", " ")
        .replaceAll("/", "-"),
    ).format(DATE_TIME_FORMAT.DATE_JP_TIME);
    return dateTime === "Invalid Date" ? "1970年01月01日 00:00" : dateTime;
  }
};

export const formatNumberToString = (
  value: number,
  columnId?: string,
  unit?: string,
  unitPosition?: AppPartType["unit_of_measure_type"],
  numberOfDecimal?: number,
  isUseThousandsSeparators?: boolean,
) => {
  if (isNaN(value)) return "";
  let formattedValue: string;
  if (typeof numberOfDecimal === "number") {
    const factor = Math.pow(10, numberOfDecimal);
    const valueNumber = Math.floor(value * factor) / factor;

    formattedValue = new Intl.NumberFormat("ja-JP", {
      minimumFractionDigits: numberOfDecimal,
      maximumFractionDigits: numberOfDecimal,
    }).format(valueNumber);
  } else if (columnId === "number") {
    formattedValue = Intl.NumberFormat("ja-JP", {
      maximumFractionDigits: 2,
    }).format(value);
  } else {
    const [intPart, decimalPart] = value.toString().split(".");
    formattedValue =
      Intl.NumberFormat("ja-JP").format(Number(intPart)) +
      (decimalPart ? "." + decimalPart : "");
  }
  if (!isUseThousandsSeparators) {
    formattedValue = formattedValue.replaceAll(",", "");
  }

  return unit
    ? unitPosition === "frefix_suffix"
      ? `${unit} ${formattedValue} ${unit}`
      : unitPosition === "frefix"
      ? `${unit} ${formattedValue}`
      : `${formattedValue} ${unit}`
    : formattedValue;
};

export const getDisplayText = (appPart: AppPartType, valueRaw: string) => {
  try {
    if (
      appPart.app_part_type === APP_PART_TYPES.DATE ||
      appPart.app_part_type === APP_PART_TYPES.DATE_AND_TIME ||
      appPart.app_part_type === APP_PART_TYPES.TIME ||
      appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
    ) {
      const partTypeToUse =
        appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
          ? APP_PART_TYPES.DATE
          : appPart.app_part_type;
      return getTextTimeCell(partTypeToUse, valueRaw);
    } else if (appPart.app_part_type === APP_PART_TYPES.NUMBER) {
      const isUseThousandsSeparators = appPart.is_use_thousands_separators;
      const numberOfDecimal = appPart.number_of_decimal_place;
      const unitPosition = appPart.unit_of_measure_type;
      const unit = appPart.unit_of_measure;
      const columnId = appPart.id + "";
      let value: number;

      if (typeof valueRaw === "number") {
        value = valueRaw;
      } else {
        const numericString = String(valueRaw)
          .replaceAll(unit, "")
          .replace(/,/g, "");
        value = Number(numericString);
      }
      return formatNumberToString(
        value,
        columnId,
        unit,
        unitPosition as any,
        numberOfDecimal,
        isUseThousandsSeparators,
      );
    } else if (appPart.app_part_type === APP_PART_TYPES.PRIMARY_COMPANY_NAME) {
      return getPrimaryCompanyNameDisplayText();
    } else if (appPart.app_part_type === APP_PART_TYPES.EMPLOYEE_SIGNATURE) {
      return valueRaw ? "(署名あり)" : "(署名なし)";
    }
    return valueRaw;
  } catch (error) {
    console.log(error);
  }
};
